/**
 * Password Reset API functions
 */
import api from './client';

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  new_password: string;
}

export interface MessageResponse {
  message: string;
}

/**
 * Request a password reset email
 */
export const forgotPassword = async (email: string): Promise<MessageResponse> => {
  const response = await api.post<MessageResponse>('/api/auth/forgot-password', { email });
  return response.data;
};

/**
 * Reset password using token from email
 */
export const resetPassword = async (token: string, newPassword: string): Promise<MessageResponse> => {
  const response = await api.post<MessageResponse>('/api/auth/reset-password', {
    token,
    new_password: newPassword,
  });
  return response.data;
};
